import { useEffect } from 'react';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { logger } from '@/lib/utils/logger';

const describeRouteError = (error: unknown): string => {
  if (isRouteErrorResponse(error)) {
    return `${error.status} ${error.statusText}`;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return 'Erreur de routage inconnue';
  }
};

export const RouteError = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const message = describeRouteError(error);

  useEffect(() => {
    logger.error(error ?? 'Route error', {
      source: 'react-router',
      routeMessage: message
    });
  }, [error, message]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-bold">Oups !</h1>
      <p className="text-muted-foreground max-w-lg">
        {message}
      </p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button variant="outline" onClick={() => navigate(-1)}>
          Revenir à la page précédente
        </Button>
        <Button onClick={() => navigate('/', { replace: true })}>
          Aller à l'accueil
        </Button>
      </div>
    </div>
  );
};
